import { DeliveryStatus } from 'state/order/types';

// these props are urlParams passed in by the router
export interface ISupportPageV2Props {
  categoryId?: string;
  subcategoryId?: string;
  rbiOrderId?: string;
}

export const invalidStatusesWhileEnroute = new Set([
  DeliveryStatus.ORDER_CANCELLED,
  DeliveryStatus.ORDER_ABANDONED,
  DeliveryStatus.ORDER_DROPPED_OFF,
]);
